import { seedBusinesses, seedDeals, seedProvinces } from "data/dbsSeed";
import { seedAds } from "data/seedAds";
import {
  seedAppConfig,
  seedPaymentPlans,
  seedTravelBuses,
  seedTravelCars,
  seedTravelFlights,
  seedTravelHotels,
  seedTravelTours,
} from "data/seedMobileCms";

export const adminSeedCollections = {
  provinces: seedProvinces,
  deals: seedDeals,
  businesses: seedBusinesses,
  ads: seedAds,
  supportRequests: [],
  paymentPlans: seedPaymentPlans,
  travelFlights: seedTravelFlights,
  travelBuses: seedTravelBuses,
  travelHotels: seedTravelHotels,
  travelTours: seedTravelTours,
  travelCars: seedTravelCars,
  appConfig: seedAppConfig,
  alerts: [],
  userFavorites: [],
  bookings: [
    {
      id: "bk-demo-1",
      businessId: "b-1",
      customerUserId: "u-customer-demo",
      customerDisplayName: "Demo Misafir",
      customerName: "Demo Misafir",
      startDate: "2026-04-12",
      nights: 2,
      notes: "Erken giriş mümkünse tercih edilir.",
      createdAt: "2026-03-01T09:00:00.000Z",
      status: "pending",
    },
    {
      id: "bk-demo-2",
      businessId: "b-2",
      customerUserId: "u-customer-demo",
      customerDisplayName: "Demo Misafir",
      customerName: "Demo Misafir",
      startDate: "2026-05-03",
      nights: 1,
      notes: "Akşam yemeği dahil olsun.",
      createdAt: "2026-03-02T12:30:00.000Z",
      status: "confirmed",
    },
  ],
  subscriptions: [
    {
      id: "sub-u-business-trabzon",
      userId: "u-business-trabzon",
      planId: "pro-monthly",
      status: "active",
      startedAt: "2026-03-01T00:00:00.000Z",
      expiresAt: "2026-04-01T00:00:00.000Z",
      createdAt: "2026-03-01T00:00:00.000Z",
      updatedAt: "2026-03-01T00:00:00.000Z",
    },
    {
      id: "sub-u-agency-artvin",
      userId: "u-agency-artvin",
      planId: "basic-monthly",
      status: "cancelled",
      startedAt: "2026-02-10T00:00:00.000Z",
      expiresAt: "2026-03-10T00:00:00.000Z",
      createdAt: "2026-02-10T00:00:00.000Z",
      updatedAt: "2026-03-05T00:00:00.000Z",
    },
  ],
  users: [
    {
      uid: "u-admin-demo",
      email: "admin@destinasyon360.local",
      displayName: "Yönetici Demo",
      role: "admin",
      createdAt: "2026-01-01T00:00:00.000Z",
      lastLoginAt: "2026-03-15T08:00:00.000Z",
    },
    {
      uid: "u-business-trabzon",
      email: "partner-trabzon@destinasyon360.local",
      displayName: "Trabzon İş Ortağı",
      role: "business",
      createdAt: "2026-01-05T00:00:00.000Z",
      lastLoginAt: "2026-03-14T10:00:00.000Z",
    },
    {
      uid: "u-agency-artvin",
      email: "agency-artvin@destinasyon360.local",
      displayName: "Artvin Acente",
      role: "agency",
      createdAt: "2026-01-08T00:00:00.000Z",
      lastLoginAt: "2026-03-13T11:30:00.000Z",
    },
    {
      uid: "u-guide-sinop",
      email: "guide-sinop@destinasyon360.local",
      displayName: "Sinop Rehber",
      role: "guide",
      createdAt: "2026-01-12T00:00:00.000Z",
      lastLoginAt: "2026-03-10T15:45:00.000Z",
    },
    {
      uid: "u-customer-demo",
      email: "customer@destinasyon360.local",
      displayName: "Demo Misafir",
      role: "customer",
      createdAt: "2026-02-01T00:00:00.000Z",
      lastLoginAt: "2026-03-15T20:00:00.000Z",
    },
  ],
};
